module.exports = __webpack_public_path__ + "static/img/vipbgimg-h.38cec0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/header/img/vipbgimg-h.png
// module id = HLOQ
// module chunks = 2